export default "__VITE_ASSET__82yNmTiH__"